import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect } from 'react';
export default function useMount(effect) {
  useEffect(function () {
    var clean = function clean() {};
    function doEffect() {
      return _doEffect.apply(this, arguments);
    }
    function _doEffect() {
      _doEffect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return effect();
            case 2:
              clean = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _doEffect.apply(this, arguments);
    }
    doEffect();
    return function () {
      return typeof clean === 'function' && clean();
    };
  }, []); // eslint-disable-line
}